import React from "react";
import CharacterLetterView from "components/common/character/CharacterLetterView";
import { useTopicRelateAnswer } from "../../../provider/TopicRelateAnswer";
import { CharacterResult } from "common/character/dto/CharacterResult";

type AnswerContainLetterViewProps = {
  letter: string;
};

const AnswerContainLetterView = ({ letter }: AnswerContainLetterViewProps) => {
  const { selector } = useTopicRelateAnswer();
  const character: CharacterResult | null = React.useMemo(
    () => selector.byLetter(letter),
    [letter, selector]
  );

  return (
    <>
      {character && <CharacterLetterView character={character} />}
      {!character && letter}
    </>
  );
};

export default AnswerContainLetterView;
